import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 p-0" }
const _hoisted_2 = { class: "d-flex justify-content-between mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  class: "d-flex justify-content-center",
  style: {"max-width":"300px"}
}
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AddDrawBundleModal = _resolveComponent("AddDrawBundleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-lg btn-primary", {
            disabled: ['close', 'initialized', 'drawn'].includes(_ctx.draw.status),
          }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newData && _ctx.newData(...args))),
            disabled: 
            !!_ctx.loadingState ||
            ['close', 'initialized', 'drawn'].includes(_ctx.draw.status)
          
          }, [
            _hoisted_6,
            _createTextVNode(" Add Bundle ")
          ], 10, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_DataTable, {
          "table-data": _ctx.bundlesTable.items,
          "table-header": _ctx.bundleTableHeader,
          "enable-items-per-page-dropdown": true,
          loading: _ctx.bundlesTable.loading,
          "rows-per-page": 10,
          "row-class": "table-hover",
          ref: "drawTable",
          total: _ctx.bundlesTable.total
        }, {
          "cell-amount": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(_ctx.formatMoney(item.amount)), 1)
          ]),
          "cell-quantity": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.quantity), 1)
          ]),
          "cell-description": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.description), 1)
          ]),
          "cell-entries": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.entries), 1)
          ]),
          "cell-active": _withCtx(({ row: item }) => [
            _createVNode(_component_Chip, {
              type: _ctx.getStatus(item).type,
              text: _ctx.getStatus(item).text
            }, null, 8, ["type", "text"])
          ]),
          "cell-action": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1", {
                disabled:
                  ['close', 'open', 'drawn'].includes(item.status) ||
                  item.entries > 0,
              }]),
                title: 
                item.entries
                  ? 'Cannot modify/remove draw bundle with entries'
                  : 'Edit Draw Bundle'
              ,
                onClick: ($event: any) => (_ctx.editData(item)),
                href: "javascript:void(0)"
              }, _hoisted_11, 10, _hoisted_9),
              _createElementVNode("a", {
                class: _normalizeClass(["btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1", {
                disabled:
                  ['close', 'open', 'drawn'].includes(item.status) ||
                  item.entries > 0,
              }]),
                title: 
                item.entries
                  ? 'Cannot modify/remove draw bundle with entries'
                  : 'Edit Bundle'
              ,
                onClick: ($event: any) => (_ctx.confirmDelete(item)),
                href: "javascript:void(0)"
              }, _hoisted_14, 10, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "loading", "total"])
      ])
    ]),
    _createVNode(_component_AddDrawBundleModal, {
      modelValue: _ctx.showCreateModal,
      onFormSubmitted: _ctx.handleDataChanged,
      onClose: _ctx.handleCancel
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"])
  ], 64))
}